import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/links';
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const check = () => {
      const first = document.getElementById('first-cta');
      if (!first) return;
      setVisible(first.getBoundingClientRect().bottom < 0);
    };
    check();
    window.addEventListener('scroll', check, {
      passive: true
    });
    window.addEventListener('resize', check);
    return () => {
      window.removeEventListener('scroll', check);
      window.removeEventListener('resize', check);
    };
  }, []);
  return <AnimatePresence data-id="element-124" data-mp="bq9hewfbfk3e">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 bg-white/95 px-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))] pt-3 shadow-[0_-8px_24px_-12px_rgba(14,28,58,0.35)] backdrop-blur sm:inset-x-auto sm:bottom-5 sm:right-5 sm:rounded-2xl sm:bg-transparent sm:p-0 sm:shadow-none sm:backdrop-blur-none" data-id="element-125" data-mp="1966k55bgm6hr">
          <a href={CHECKOUT_URL} className="flex w-full items-center justify-center gap-2 rounded-2xl bg-cta px-5 py-4 text-base font-extrabold uppercase tracking-wide text-white shadow-[0_5px_0_0_#c24a07] transition-colors duration-150 ease-out hover:bg-ctaDark motion-safe:animate-shake sm:w-auto sm:px-7 sm:shadow-[0_5px_0_0_#c24a07,0_16px_30px_-10px_rgba(255,106,19,0.6)]" data-id="element-126" data-mp="26b7all8zohyl">
            <span className="whitespace-nowrap" data-id="element-127" data-mp="1ndw9dv3sregi">Get instant access · $27</span>
            <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-128" data-mp="3cr9iryqrnsoh" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}